---
title: Auto pan
description: "An auto pan device: a pan or tremolo mode, a wave shape, a rate or a note value and a depth, a panel that draws the movement, a Web Audio engine and tools for agents."
component: true
base: base
---

<ComponentPreview styleName="base-nova" name="block-auto-pan" />

Moves the sound with a slow oscillator. In Pan mode it moves from one speaker to the other. In Tremolo mode its level goes up and down. It is a [device](/docs/devices): a state, a panel, an engine and tools, each its own file.

## Installation

<Install name="auto-pan" kind="device" />

## Controls

<DeviceControls device="auto-pan">
<Control id="mode">Pan moves the sound between the speakers, Tremolo moves its level.</Control>
<Control id="shape">The wave of the oscillator: sine, triangle, saw or square.</Control>
<Control id="rateHz">How fast the oscillator moves.</Control>
<Control id="sync">Takes the rate from a note value and the tempo of the host. See [Tempo sync](/docs/devices#tempo-sync).</Control>
<Control id="division">The note value of one cycle of the oscillator.</Control>
<Control id="depth">How far the oscillator moves the pan or the level.</Control>
</DeviceControls>

## Panel

The panel draws the movement over two seconds. `autoPanWave(shape, phase)` is the wave and `autoPanSweep(state)` is what the panel draws.

<DeviceUsage name="auto-pan" />

## Engine

Create it, connect it and update it as for any device: see [The engine](/docs/devices#the-engine).

One oscillator feeds both a stereo panner and a gain, and the mode sets which of the two depths is on. In Tremolo mode the level swings around the middle of its range, so a depth of 100 % goes from silence to full level.
